import React from "react";
import "./FollowSocialStrip.css";

const SOCIAL_LINKS = [
  {
    href: "https://www.linkedin.com/company/wave-of-innovation/posts/?feedView=all",
    label: "Wave of Innovation on LinkedIn",
    icon: "linkedin",
  },
  {
    href: "https://x.com/wave_of_innov",
    label: "Wave of Innovation on X (Twitter)",
    icon: "x",
  },
  {
    href: "https://www.facebook.com/waveofinnovationHQ",
    label: "Wave of Innovation on Facebook",
    icon: "facebook",
  },
  {
    href: "https://www.instagram.com/waveofinnovation/",
    label: "Wave of Innovation on Instagram",
    icon: "instagram",
  },
  {
    href: "https://www.threads.com/@waveofinnovation",
    label: "Wave of Innovation on Threads",
    icon: "threads",
  },
  // {
  //   href: "https://www.youtube.com/@waveofinnovation",
  //   label: "Wave of Innovation on YouTube",
  //   icon: "youtube",
  // },
  // {
  //   href: "mailto:office@waveofinnovation.com",
  //   label: "Email Wave of Innovation",
  //   icon: "email",
  // },
] as const;

function SocialIcon({ name }: { name: (typeof SOCIAL_LINKS)[number]["icon"] }) {
  switch (name) {
    case "x":
      return (
        <svg className="follow-social-strip-svg" viewBox="0 0 24 24" aria-hidden>
          <path
            fill="currentColor"
            d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
          />
        </svg>
      );
    case "facebook":
      return (
        <svg className="follow-social-strip-svg" viewBox="0 0 24 24" aria-hidden>
          <path
            fill="currentColor"
            d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.43c0-3.007 1.792-4.668 4.533-4.668 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"
          />
        </svg>
      );
    case "linkedin":
      return (
        <svg className="follow-social-strip-svg" viewBox="0 0 24 24" aria-hidden>
          <path
            fill="currentColor"
            d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
          />
        </svg>
      );
    // case "youtube":
    //   return (
    //     <svg className="follow-social-strip-svg" viewBox="0 0 24 24" aria-hidden>
    //       <path
    //         fill="currentColor"
    //         d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
    //       />
    //     </svg>
    //   );
    case "instagram":
      return (
        <svg className="follow-social-strip-svg" viewBox="0 0 24 24" aria-hidden>
          <path
            fill="currentColor"
            d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
          />
        </svg>
      );
    case "threads":
      return (
        <svg className="follow-social-strip-svg" viewBox="0 0 24 24" aria-hidden>
          <path
            fill="currentColor"
            d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.964-.065-1.19.408-2.285 1.33-3.082.88-.76 2.119-1.207 3.583-1.291a13.853 13.853 0 0 1 3.02.142c-.126-.742-.375-1.332-.75-1.757-.513-.586-1.308-.883-2.359-.89h-.029c-.844 0-1.992.232-2.721 1.32L7.734 7.847c.98-1.454 2.568-2.256 4.478-2.256h.044c3.194.02 5.097 1.975 5.287 5.388.108.046.216.094.321.142 1.49.7 2.58 1.761 3.154 3.07.797 1.82.871 4.79-1.548 7.158-1.85 1.81-4.094 2.628-7.277 2.65Zm1.003-11.69c-.242 0-.487.007-.739.021-1.836.103-2.98.946-2.916 2.143.067 1.256 1.452 1.839 2.784 1.767 1.224-.065 2.818-.543 3.086-3.71a10.5 10.5 0 0 0-2.215-.221z"
          />
        </svg>
      );
    // case "email":
    //   return (
    //     <svg className="follow-social-strip-svg" viewBox="0 0 24 24" aria-hidden>
    //       <path
    //         fill="currentColor"
    //         d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 4.99L4 8V6l8 5 8-5v2zm0 10H4v-7.5l7.29 4.55c.33.21.74.21 1.07 0L20 14.5V18z"
    //       />
    //     </svg>
    //   );
    default:
      return null;
  }
}

export interface FollowSocialStripProps {
  /** `onDark` — light icons for dark backgrounds (e.g. footer); default is black on light. */
  variant?: "default" | "onDark";
  /** Show “Follow Wave of Innovation” before the icons (e.g. newsletter panel). Footer leaves this off. */
  showLabel?: boolean;
  className?: string;
}

const FollowSocialStrip: React.FC<FollowSocialStripProps> = ({
  variant = "default",
  showLabel = false,
  className = "",
}) => {
  const rootClass = [
    "follow-social-strip",
    variant === "onDark" ? "follow-social-strip--on-dark" : "",
    showLabel ? "follow-social-strip--with-label" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <nav className={rootClass} aria-label="Follow Wave of Innovation">
      <div className="follow-social-strip-inner">
        {showLabel ? (
          <span className="follow-social-strip-label">Follow Wave of Innovation</span>
        ) : null}
        <ul className="follow-social-strip-list">
          {SOCIAL_LINKS.map((item) => (
            <li key={item.label}>
              <a
                href={item.href}
                className="follow-social-strip-link"
                aria-label={item.label}
                {...(item.href.startsWith("mailto:")
                  ? {}
                  : { target: "_blank", rel: "noopener noreferrer" })}
              >
                <SocialIcon name={item.icon} />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default FollowSocialStrip;
